var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('app-sidebar',{attrs:{"drawer":_vm.drawer},on:{"update:drawer":function($event){_vm.drawer=$event}}}),_c('app-header',{on:{"toggle-drawer":function($event){_vm.drawer = !_vm.drawer}}}),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }